import React, { useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

// Register ChartJS components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ActivityDistributionChart = ({ activityStatistics }) => {
  console.log('[ActivityDistributionChart] Rendering with statistics:', activityStatistics);
  
  useEffect(() => {
    console.log('[ActivityDistributionChart] Component mounted/updated with activity statistics:', 
      activityStatistics ? `${activityStatistics.length} items` : 'none');
    return () => console.log('[ActivityDistributionChart] Component unmounting');
  }, [activityStatistics]);
  if (!activityStatistics || activityStatistics.length === 0) {
    console.log('[ActivityDistributionChart] No activity data available, showing empty state');
    return <div>No activity data available</div>;
  }

  // Check data format and normalize it
  const isArrayFormat = Array.isArray(activityStatistics[0]);
  console.log('[ActivityDistributionChart] Data format check - Array format:', isArrayFormat);
  
  // Convert the activities to a consistent format
  const normalizedActivities = isArrayFormat
    ? activityStatistics.map(item => ({
        activity_name: item[0],
        nr_of_events: item[1]
      }))
    : activityStatistics;
  
  console.log('[ActivityDistributionChart] Normalized activities:', normalizedActivities);
  
  // Sort activities by count (descending)
  const sortedActivities = [...normalizedActivities].sort((a, b) => b.nr_of_events - a.nr_of_events);
  console.log('[ActivityDistributionChart] Sorted activities:', sortedActivities);
  
  console.log('[ActivityDistributionChart] Preparing chart data for', sortedActivities.length, 'activities');
  
  const data = {
    labels: sortedActivities.map(item => item.activity_name),
    datasets: [
      {
        label: 'Number of Events',
        data: sortedActivities.map(item => item.nr_of_events),
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Activity Distribution',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Count',
        },
      },
      x: {
        title: {
          display: true,
          text: 'Activity',
        },
      },
    },
  };

  console.log('[ActivityDistributionChart] Chart configuration complete, rendering with', data.labels.length, 'labels');
  
  return (
    <div className="mb-4">
      <h3>Activity Distribution</h3>
      <div style={{ height: '400px' }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default ActivityDistributionChart;